import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import AboutBrief from "@/components/AboutBrief";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import HowItWorks from "@/components/HowItWorks";
import Gallery from "@/components/Gallery";
import TrustStats from "@/components/TrustStats";
import Testimonials from "@/components/Testimonials";
import ServiceArea from "@/components/ServiceArea";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
    useEffect(() => {
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        obs.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
        );
        document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);

    return (
        <main data-testid="landing-root" className="relative">
            <Nav />
            <Hero />
            <AboutBrief />
            <Services />
            <WhyChooseUs />
            <HowItWorks />
            <Gallery />
            <TrustStats />
            <Testimonials />
            <ServiceArea />
            <About />
            <Contact />
            <Footer />
        </main>
    );
}
